export const CategoryLandingPageBannerDynamic = ({ pageFolder }) => {
  const bannerData = pageFolder?.dataSourceConfigurations?.[0]?.preloadedValue;
  const imageBannerMobile = bannerData?.imageBannerMobile ?? null;
  const imageBannerDesktop = bannerData?.imageBannerDesktop ?? null;
  const bannerOverlayH1TextMobile = bannerData?.bannerOverlayH1TextMobile ?? null;
  const bannerOverlayH1TextDesktop = bannerData?.bannerOverlayH1TextDesktop ?? null;
  const bannerOverlayTextMobile = bannerData?.bannerOverlayTextMobile ?? null;
  const bannerOverlayTextDesktop = bannerData?.bannerOverlayTextDesktop ?? null;

  if (imageBannerMobile || imageBannerDesktop) {
    return (
      <div className="relative aspect-[864/800] w-full md:aspect-[24/5]">
        <div className="absolute inset-0 h-full w-full">
          <picture className="block h-full w-full">
            {imageBannerMobile && <source srcSet={imageBannerMobile} media="(max-width: 767px)" />}
            <img
              src={imageBannerDesktop || imageBannerMobile}
              className="h-full w-full object-cover object-center"
              alt=""
            />
          </picture>
        </div>

        {(bannerOverlayH1TextMobile || bannerOverlayTextMobile) && (
          <div className="pointer-events-none absolute left-1/2 top-[14%] z-10 flex w-[80%] -translate-x-1/2 flex-col items-center gap-5 text-white md:hidden">
            {bannerOverlayH1TextMobile && (
              <h1 className="w-full whitespace-pre-line break-words text-center font-['Akshar'] text-[34px] font-bold leading-[1.05]">
                {bannerOverlayH1TextMobile}
              </h1>
            )}
            {bannerOverlayTextMobile && (
              <div className="w-full whitespace-pre-line break-words text-center font-galanoClassic text-[20px] font-normal leading-[1.2]">
                {bannerOverlayTextMobile}
              </div>
            )}
          </div>
        )}

        {(bannerOverlayH1TextDesktop || bannerOverlayTextDesktop) && (
          <div className="pointer-events-none absolute inset-y-0 left-[4%] z-10 hidden w-[44%] flex-col items-start justify-center gap-6 text-white md:flex">
            {bannerOverlayH1TextDesktop && (
              <h1 className="w-full whitespace-pre-line break-words text-left font-['Akshar'] text-[48px] font-bold leading-[1.05]">
                {bannerOverlayH1TextDesktop}
              </h1>
            )}
            {bannerOverlayTextDesktop && (
              <div className="w-full whitespace-pre-line break-words text-left font-galanoClassic text-[22px] font-normal leading-[1.2]">
                {bannerOverlayTextDesktop}
              </div>
            )}
          </div>
        )}
      </div>
    );
  } else {
    return null;
  }
};
